import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=b2c86c78&"
import script from "./sync.vue?vue&type=script&lang=ts&"
export * from "./sync.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports